export enum DIALOG_TYPES {
  CREATE,
  EDIT,
  DELETE,
  IS_ACTIVE,
  ADD_CREDIT
}
